import { getData, isAuth, postData } from "actions";
import {
  FooterPortal,
  NavbarPortal,
  RatingButtons,
  SearchPortal,
} from "components";
import {
  API_URL_createThreadTicket,
  API_URL_rating,
  API_URL_ticket,
  API_URL_ticketPortal,
  base,
} from "constants/api";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import {
  FaFileExcel,
  FaFileImage,
  FaFilePdf,
  FaFilePowerpoint,
  FaFileWord,
  FaPaperclip,
  FaRegClock,
  FaTicketAlt,
} from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ticketReducers } from "redux/ticketSlice";
import { byteToKiloByte } from "utils/byteToKiloByte";
import { removeTicketPrefix } from "utils/removeTicketPrefix";
import { CKEditor } from "ckeditor4-react";
import { ratingReducers } from "redux/ratingSlice";
import { capitalAllLetters } from "utils/capitalAllLetters";
import { getExtensionFile } from "utils/getExtensionFile";

const TicketDetailPortal = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const state = location.state ? location.state : "";
  const [refreshEditor, setRefreshEditor] = useState(false);

  // function color dan icon
  function getColorClass(type) {
    switch (type) {
      case "xlsx":
        return "bg-green-200";
      case "XLSX":
        return "bg-green-200";
      case "xls":
        return "bg-green-200";
      case "XLS":
        return "bg-green-200";
      case "ppt":
        return "bg-orange-200";
      case "PPT":
        return "bg-orange-200";
      case "pptx":
        return "bg-orange-200";
      case "PPTX":
        return "bg-orange-200";
      case "docx":
        return "bg-blue-200";
      case "DOCX":
        return "bg-blue-200";
      case "doc":
        return "bg-blue-200";
      case "DOC":
        return "bg-blue-200";
      case "pdf":
        return "bg-red-200";
      case "PDF":
        return "bg-red-200";
      case "png":
        return "bg-violet-200";
      case "PNG":
        return "bg-violet-200";
      case "jpg":
        return "bg-violet-200";
      case "jpeg":
        return "bg-violet-200";
      case "JPG":
        return "bg-violet-200";
      case "JPEG":
        return "bg-violet-200";
      default:
        return "";
    }
  }

  function getIcon(type) {
    switch (type) {
      case "xlsx":
        return <FaFileExcel className="mr-2 bg-" />;
      case "XLSX":
        return <FaFileExcel className="mr-2 bg-" />;
      case "xls":
        return <FaFileExcel className="mr-2" />;
      case "XLS":
        return <FaFileExcel className="mr-2" />;
      case "ppt":
        return <FaFilePowerpoint className="mr-2" />;
      case "PPT":
        return <FaFilePowerpoint className="mr-2" />;
      case "pptx":
        return <FaFilePowerpoint className="mr-2" />;
      case "PPTX":
        return <FaFilePowerpoint className="mr-2" />;
      case "docx":
        return <FaFileWord className="mr-2" />;
      case "DOCX":
        return <FaFileWord className="mr-2" />;
      case "doc":
        return <FaFileWord className="mr-2" />;
      case "DOC":
        return <FaFileWord className="mr-2" />;
      case "pdf":
        return <FaFilePdf className="mr-2" />;
      case "PDF":
        return <FaFilePdf className="mr-2" />;
      case "png":
        return <FaFileImage className="mr-2" />;
      case "jpg":
        return <FaFileImage className="mr-2" />;
      case "jpeg":
        return <FaFileImage className="mr-2" />;
      case "PNG":
        return <FaFileImage className="mr-2" />;
      case "JPG":
        return <FaFileImage className="mr-2" />;
      case "JPEG":
        return <FaFileImage className="mr-2" />;
      default:
        return null; // Tidak ada ikon jika tidak ada jenis yang cocok
    }
  }

  const { getTicketResult, getRatingResult } = useSelector((state) => ({
    getTicketResult: state.ticket.getTicketResult,
    getRatingResult: state.rating.getRatingResult,
  }));

  const getTicket = useCallback(
    async (params) => {
      getData(
        API_URL_ticketPortal,
        params,
        { dispatch, redux: ticketReducers },
        "GET_TICKET"
      );
    },
    [dispatch]
  );

  const fetchRating = useCallback(
    async (params) => {
      getData(
        API_URL_rating,
        params,
        { dispatch, redux: ratingReducers },
        "GET_RATING"
      );
    },
    [dispatch]
  );

  const formikReply = useFormik({
    initialValues: {
      body: "",
      file: false,
    },
    validationSchema: Yup.object({
      body: Yup.string().required("Pesan is required"),
    }),
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("title", getTicketResult.data?.ticket_thread[0].title);
      formData.append("ip_address", "0.0.0.0");
      formData.append("is_internal", 0);
      formData.append("body", values.body);
      formData.append("source", 3);
      formData.append("ticket", state.id);
      formData.append("user", getTicketResult.data?.user);
      if (values.file !== false) formData.append("file", values.file);

      postData(
        `${API_URL_createThreadTicket}`,
        formData,
        { dispatch, redux: ticketReducers },
        "ADD_TICKET",
        () => {
          formikReply.resetForm();
          setRefreshEditor(!refreshEditor);
          formikReply.setFieldValue("body", " ");
          const params = `${state.id}/?client=1`;
          getTicket(params);
        }
      );
    },
  });
  const handleFetch = () => {
    const params = `${state.id}/?client=1`;
    getTicket(params);
  };

  useEffect(() => {
    if (state.id !== undefined) {
      const params = `${state.id}/?client=1`;
      getTicket(params);
    }
  }, [state]);

  const toolbarConfig = {
    extraPlugins: "font,colorbutton,colordialog",
    removePlugins: "about,image",
    skin: "moono",
  };

  useEffect(() => {
    fetchRating("1/");
    if (state === "") {
      navigate("/tiketsaya");
    }
    if (isAuth === undefined) {
      navigate("/");
    }
  }, []);

  return (
    <>
      <div className="flex flex-col min-h-screen overflow-y-auto text-gray-700">
        <NavbarPortal current={"Tiket Saya"} />
        <SearchPortal />

        <main className="flex flex-grow">
          <div className="mx-auto w-full max-w-[90rem] md:px-8 bg-transparent">
            <div className="relative mx-1 md:mx-0 bottom-6 bg-neutral-50 shadow-sm shadow-sky-800 rounded">
              <div className="mx-4 md:mx-10 py-2 md:py-4">
                {/* title ticket  */}
                <div className="flex flex-wrap items-center">
                  <FaTicketAlt className="mr-2 text-4xl text-green-500" />
                  <p className="text-2xl font-bold">
                    {getTicketResult.data && getTicketResult.data?.title}{" "}
                  </p>
                  <p className="ml-1 mt-1 text-xl align-text-bottom">
                    (
                    {getTicketResult.data &&
                      getTicketResult.data?.ticket_number}
                    )
                  </p>
                </div>

                {/* Rating ticket */}
                <div className="flex justify-end gap-2 items-center">
                  <p className="font-bold">
                    {getRatingResult && getRatingResult.name}
                  </p>
                  <RatingButtons
                    item={getTicketResult.data && getTicketResult.data}
                    callback={() => handleFetch()}
                  />
                </div>

                {/* about ticket */}
                <div className="bg-white shadow-md shadow-gray-400">
                  <span className="absolute bg-[#f9fafb] rounded-full px-3 py-3 left-[0.3rem] top-[8rem] md:left-[1.8rem] md:top-[6rem] lg:left-[1.8rem] lg:top-[5.5rem]"></span>
                  <span className="absolute bg-[#f9fafb] rounded-full px-3 py-3 right-[0.3rem] top-[8rem] md:right-[1.8rem] md:top-[6rem] lg:right-[1.8rem] lg:top-[5.5rem]"></span>

                  <div
                    style={{
                      backgroundColor: getTicketResult.data?.priority_color,
                    }}
                    className=" px-8 py-4 border-dotted border-b-4  border-white  text-white dark:text-white"
                  >
                    {getTicketResult.data && (
                      <div className="grid grid-cols-12">
                        <div className="col-span-12 md:col-span-6 lg:col-span-3">
                          <b>SLA Plan: </b>
                          <span>{getTicketResult.data?.sla_name}</span>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3">
                          <b>Tanggal Tiket: </b>
                          <span>
                            {moment(getTicketResult.data?.created_at).format(
                              "DD/MM/YYYY HH:mm:ss"
                            )}
                          </span>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3">
                          <b>Batas Waktu: </b>
                          <span>
                            {moment(getTicketResult.data?.duedate).format(
                              "DD/MM/YYYY HH:mm:ss"
                            )}
                          </span>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3">
                          <b>Respon Terakhir: </b>
                          <span>
                            {moment(getTicketResult.data?.updated_at).format(
                              "DD/MM/YYYY HH:mm:ss"
                            )}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* information ticket  */}
                  <div className="grid grid-cols-12 gap-4 mb-4 p-4 ">
                    {getTicketResult.data && (
                      <>
                        <div className="col-span-12 md:col-span-6">
                          <table className="w-full">
                            <tbody>
                              <tr className="h-10  hover:bg-neutral-200">
                                <td>
                                  <b>Status :</b>
                                </td>
                                <td className="text-green-500">
                                  {getTicketResult.data?.status_name}
                                </td>
                              </tr>
                              <tr className="h-10  hover:bg-neutral-200">
                                <td>
                                  <b>Prioritas :</b>
                                </td>
                                <td className="text-yellow-600">
                                  {getTicketResult.data?.priority_name}
                                </td>
                              </tr>
                              <tr className="h-10  hover:bg-neutral-200">
                                <td>
                                  <b>Email :</b>
                                </td>
                                <td>{getTicketResult.data?.user_email}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div className="col-span-12 md:col-span-6">
                          <table className="w-full">
                            <tbody>
                              <tr className="h-10  hover:bg-neutral-200">
                                <td>
                                  <b>Nama Client :</b>
                                </td>
                                <td>{getTicketResult.data?.client_name}</td>
                              </tr>
                              <tr className="h-10  hover:bg-neutral-200">
                                <td>
                                  <b>Aktivitas Pesan Terakhir :</b>
                                </td>
                                <td>
                                  {getTicketResult.data?.last_replier_name}
                                </td>
                              </tr>
                              <tr className="h-10  hover:bg-neutral-200">
                                <td>
                                  <b>Departement :</b>
                                </td>
                                <td>{getTicketResult.data?.dept_name}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </>
                    )}
                  </div>
                </div>

                {/* thread ticket  */}
                <div>
                  {getTicketResult.data &&
                    getTicketResult.data.ticket_thread
                      .slice()
                      .reverse()
                      .map((item, index) => {
                        const idUserPenanya =
                          getTicketResult.data &&
                          getTicketResult.data.ticket_thread.length > 0 &&
                          getTicketResult.data.ticket_thread[
                            getTicketResult.data.ticket_thread.length - 1
                          ].user;
                        return (
                          <div
                            className="ml-6 border-l-2 border-b-2 mb-4"
                            key={index}
                          >
                            {/* Title  */}
                            <div className="flex">
                              <img
                                className={`w-12 h-12 rounded border-2 relative right-6
                                ${
                                  idUserPenanya === item.user
                                    ? "shadow-green-300 border-green-400"
                                    : "shadow-yellow-300 border-yellow-400"
                                } shadow `}
                                src={item.avatar}
                                alt="User Avatar"
                              />
                              <div
                                className={`flex flex-col ${
                                  idUserPenanya === item.user
                                    ? "bg-green-100"
                                    : "bg-yellow-100"
                                } border shadow border-gray-400 w-full`}
                              >
                                <p className="ml-4 font-semibold">
                                  {item.client_name}
                                </p>
                                <div className="flex ml-4 items-center">
                                  <FaRegClock className="mr-1 text-xs text-gray-500" />
                                  <p className="block text-sm font-normal text-gray-500 dark:text-gray-500">
                                    {moment(item.created_at).format(
                                      "DD MMMM YYYY, HH:mm:ss"
                                    )}
                                  </p>
                                </div>
                              </div>
                            </div>

                            {/* content  */}
                            <div className="ml-8 p-1 px-4 mb-4 mt-3  text-base font-normal text-black dark:text-white">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.body_view,
                                }}
                                className="block mb-4 ck-editor-content"
                              ></div>
                              <div className=" flex flex-wrap gap-4">
                                {item.ticket_attachment &&
                                  item.ticket_attachment.map((item, index) => (
                                    <a
                                      key={index}
                                      className="border-2 min-w-min text-center"
                                      href={`${base}${item.name}`}
                                      target="_blank"
                                    >
                                      <div
                                        className={`border-b h-10 flex justify-center items-center ${getColorClass(
                                          getExtensionFile(item.name)
                                        )}`}
                                      >
                                        {getIcon(getExtensionFile(item.name))}
                                        {capitalAllLetters(
                                          getExtensionFile(item.name)
                                        )}
                                      </div>
                                      {getExtensionFile(item.name) === "jpg" ||
                                      getExtensionFile(item.name) === "png" ||
                                      getExtensionFile(item.name) === "webp" ||
                                      getExtensionFile(item.name) === "jpeg" ? (
                                        <img
                                          src={`${base}${item.name}`}
                                          className="w-40 h-36"
                                        />
                                      ) : (
                                        <div className="text-center px-4 text-xs md:text-base">
                                          {removeTicketPrefix(item.name)}
                                        </div>
                                      )}
                                      <div className="text-xs md:text-base">
                                        {byteToKiloByte(item.size)} KB
                                      </div>
                                    </a>
                                  ))}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                </div>

                {/* Post Reply */}
                <div>
                  <form onSubmit={formikReply.handleSubmit}>
                    <label className="col-span-12 font-bold block">
                      Balas Pesan
                      <CKEditor
                        key={refreshEditor}
                        config={toolbarConfig}
                        type="classic"
                        data={formikReply.values.body}
                        onChange={(e) => {
                          formikReply.setFieldValue("body", e.editor.getData());
                        }}
                      />
                      {formikReply.touched.body && formikReply.errors.body && (
                        <div className="text-red-500 text-xs">
                          {formikReply.errors.body}
                        </div>
                      )}
                    </label>

                    <div className="col-span-12 md:col-span-2">
                      <label className="font-bold">Attachment :</label>
                    </div>
                    <div className="col-span-12 md:col-span-10">
                      <div className="flex items-center">
                        <label className="p-1 px-3 flex items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 dark:bg-neutral-700 dark:border-neutral-700 text-gray-900 dark:text-white">
                          <FaPaperclip />
                          <span>Choose File</span>
                          <input
                            type="file"
                            id="file"
                            name="file"
                            className="hidden"
                            onChange={(e) => {
                              formikReply.setFieldValue(
                                "file",
                                e.target.files[0]
                              );
                            }}
                          />
                        </label>
                        {formikReply.values.file !== false &&
                          formikReply.values.file !== undefined && (
                            <div className="ml-4">
                              {formikReply.values.file.name}{" "}
                              {byteToKiloByte(formikReply.values.file.size)}KB
                            </div>
                          )}
                      </div>
                      <p>Maximum file size 5Mb</p>
                      {formikReply.touched.file && formikReply.errors.file && (
                        <div className="text-red-500 dark:text-red-300 text-xs">
                          {formikReply.errors.file}
                        </div>
                      )}
                    </div>

                    <button
                      type="submit"
                      className="rounded-md mt-4 text-white py-1.5 w-32 bg-sky-700 hover:bg-sky-800 "
                    >
                      Submit
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </main>

        <FooterPortal />
      </div>
    </>
  );
};

export default TicketDetailPortal;
